import { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import { Divider, Box, Paper, Card, CardHeader, Button, CardActions } from '@mui/material';

import ELibraryDocument from '../../../types/legal/eLibraryDocument';
import PageBreadCrumbs from '../../../components/PageBreadcrumbs';

const Studies = (): JSX.Element => {

  const [studies, setStudies] = useState<ELibraryDocument[]>([]);


  useEffect(() => {
    getStudies();
  }, [])


  const getStudies = async () => {
    try {
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/publications/studies`)
        .then(result => result.json())
        .then(result => {
          setStudies(result)
        });
    } catch (error) {
      console.error('Uncaught Error:', error);
    }

  }


  const genCourt = studies.filter((study) => study.title?.includes('Legislative Study') || study.title?.includes('Report of Campaign Finance Activity By Candidates for the Massachusetts'));
  const statewide = studies.filter((study) => study.title?.includes('Statewide Study'));
  const pacs = studies.filter((study) => study.title?.includes('Campaign Finance Activity by Political Action Committees in Massachusett'));
  const statewideBQ = studies.filter((study) => study.title?.includes('Ballot Question Committee Study'));
  const candidatesMayor = studies.filter((study) => study.title?.includes('Mayoral Study'));
  const publicFinancing = studies.filter((study) => study.title?.includes('Public Finance Study'));
  // const other = studies.filter((study) => !study.title?.includes('Legislative Study') && !study.title?.includes('Statewide Study') && !study.title?.includes('Campaign Finance Activity by Political Action Committees in Massachusett') && !study.title?.includes('Ballot Question Committee Study') && !study.title?.includes('Mayoral Study') && !study.title?.includes('Public Finance Study') && !study.title?.includes('Report of Campaign Finance Activity By Candidates for the Massachusetts'));
  const other = [{ id: 1, title: 'State Election Campaign Fund Audit', description: '', url: 'https://ocpf2.blob.core.windows.net/pdf/studies/secf2022auditorreport.pdf' }]
  const subsections =
    [
      { id: 1, array: genCourt, title: 'Candidates for General Court (State Senate and House)' },
      { id: 2, array: statewide, title: 'Candidates for Statewide Candidates' },
      { id: 3, array: pacs, title: 'Political Action Committees (PACs)' },
      { id: 4, array: statewideBQ, title: 'State Ballot Question Committees' },
      { id: 5, array: candidatesMayor, title: 'Candidates for Mayor' },
      { id: 6, array: publicFinancing, title: 'Public Financing of Campaigns' },
      { id: 7, array: other, title: 'Other Studies' }
    ]


  return (
    <Main>
      <Container>
        <PageBreadCrumbs></PageBreadCrumbs>
        <Typography
          component={'h1'}
          variant="h4"
          align={'left'}
          data-aos={'fade-up'}
          sx={{
            fontWeight: 700,
          }}
          paddingTop={3}
          gutterBottom
          marginBottom={2}
        >
          OCPF Studies
        </Typography>
        <Divider />
        <Box component={Paper} p={2} marginBottom={2} marginTop={2}>
          <Typography variant="h5" paddingBottom={2}>OCPF Campaign Finance Activity Studies</Typography>
          <Typography variant="body1"> OCPF issues various publications to help candidates, committees, public employees and others understand the campaign finance law. Every publication is available at no cost and we will provide them via email, fax or mail upon request.</Typography>
        </Box>
        {subsections.map((object, index) => (
          <Card key={object.id} sx={{ mb: 2, display: 'flex', flexDirection: 'column' }}>
            <CardHeader sx={{ backgroundColor: '#395384', color: 'white' }}
              title={
                <Typography
                  variant="h6"  // Smaller than default h5
                >
                  {object.title}
                </Typography>
              } />
            <CardActions sx={{ flexWrap: 'wrap', gap: 1, justifyContent: 'flex-start', padding: 2 }}>
              {object.id === 7 ?
                 <>
                 <Typography >Select a study:</Typography>
                 {object.array.map((study, index) => (
                   <Button key={study.id} variant="outlined" onClick={() => window.open(study.url, '_blank')}>
                      {study.title}
                   </Button>
                 ))}
               </>

              :
                <>
                  <Typography >Select a year:</Typography>
                  {object.array.map((study, index) => (
                    <Button key={study.id} variant="outlined" onClick={() => window.open(study.url, '_blank')}>
                      {study.title?.includes('Report of Campaign Finance Activity By Candidates for the Massachusetts') ?
                        study.title?.split(' ')[0] + ' ' + (study.title?.includes('Senate') ? '(Senate)' : '(House)')
                        : study.title?.split(' ')[0]}
                    </Button>
                  ))}
                </>
              }
            </CardActions>
          </Card>

        ))}



      </Container>
    </Main>
  );
};

export default Studies;